import {
  useFormContext,
  get
} from "react-hook-form";
import {
  ChangeEvent
} from "react";

import {
  TextField
} from "../../Inputs";
import {
  InputTextFieldProps
} from "./InputTextField.types";
import {
  cleanNumber,
  formatCurrency,
  getHelperTextMessage,
  getInputType,
  validateForm
} from "./InputTextField.utils";
import {
  useDisabledField,
} from "../HookForm/HookForm.context";

export function InputTextField({
  disabled,
  name,
  rule,
  value,
  ...props
}: InputTextFieldProps) {

  const isCurrency = props.type === 'currency';

  const isDisabled = useDisabledField(name);
  const form = useFormContext();
  const error = get(form.formState.errors, name);

  const setValueAs = (value?: string) => {
    if (props.type === 'number') {
      if (value !== undefined && value !== '') {
        return isNaN(+value) ? undefined : +value;
      }
      return '';
    }
    if (isCurrency && value) {
      return cleanNumber(value);
    }
    return (value);
  }

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (isCurrency) {
      formatCurrency(event.target);
    }
    const currentError = get(form?.formState?.errors, name);
    if (currentError?.type === 'serverError' || currentError?.type === 'manual') {
      form.clearErrors(name);
    }
    rule?.onChange?.(event);
  };

  const register = form.register(name, {
    validate: validateForm(props.type, rule?.required),
    setValueAs,
    ...rule,
    onChange: handleInputChange,
  });

  const handleRef = (ref: HTMLInputElement | null) => {
    register.ref(ref);
    if (isCurrency) {
      setTimeout(() => formatCurrency(ref), 100);
    }
  };

  return (
    <TextField
      defaultValue={props.defaultValue ?? form.getValues(name)}
      {...{ ...props, ...register }}
      helperText={props.helperText ?? getHelperTextMessage(error, props)}
      required={!!rule?.required}
      prefix={isCurrency && !props.prefix ? "Rp" : props.prefix}
      type={getInputType(props.type)}
      onWheel={(e) => e?.currentTarget?.blur()}
      error={props.error ?? !!error}
      ref={handleRef}
      disabled={isDisabled || disabled}
    />
  );
}
